/**
 * Jurisdiction-default terminology.
 *
 * The future jurisdiction dictionary (jurisdiction-architecture.md §6) will
 * replace these per pack — e.g. an Ontario pack maps EXECUTOR_TERM → "Estate
 * Trustee". Until that engine exists, UI surfaces resolve the executor label
 * through THESE constants rather than hardcoding "Executor" (and never a
 * region-specific term or slash-name). New executor-facing copy must read from
 * here so the seam stays clean.
 */
export const EXECUTOR_TERM = "Executor";
export const EXECUTOR_TERM_LOWER = "executor";
export const EXECUTOR_TERM_PLURAL = "Executors";
